

import React, { Component } from "react";
import { withRouter } from "./withRouter";
import  {   Popup } from "react-map-gl";

class NZ2026HomeTooltip extends Component {
 
buildTooltip(hoverInfo, styledGeo, tooltip_pastcomp) {
  const { geoLevel } = this.props;
  if (!hoverInfo) return null;
  if (!styledGeo) return null;

  const { area_name, area_id } = hoverInfo.props;

  // Find matching feature in styledGeo
  const comparatorFeature = styledGeo.features.find(
    f => f?.properties?.area_id === area_id
  );

  // Predicted vote shares list (now: { key, area_name, value, lower, upper })
  const predictedValues = JSON.parse(hoverInfo.props._allValuesSorted);

  const partyConfig = {
    D66_GE_p: { label: "D66", color: "#2cc800" },
    PVV_GE_p: { label: "PVV", color: "#043555" },
    VVD_GE_p: { label: "VVD", color: "#0e2783" },
    GLpvdA_GE_p: { label: "GL–PvdA", color: "#920c19" },
    CDA_GE_p: { label: "CDA", color: "#339933" },
    OtherRight_GE_p: { label: "Other right", color: "#7393B3" },
    OtherLeft_GE_p: { label: "Other left", color: "#997570" },
    OtherCentre_GE_p: { label: "Other centre", color: "#999999" },
    turnout_GE_p: { label: "Turnout", color: "#999999" },

    D66_LE_p: { label: "D66", color: "#2cc800" },
    PVV_LE_p: { label: "PVV", color: "#043555" },
    VVD_LE_p: { label: "VVD", color: "#0e2783" },
    GLpvdA_LE_p: { label: "GL–PvdA", color: "#920c19" },
    CDA_LE_p: { label: "CDA", color: "#339933" },
    OtherRight_LE_p: { label: "Other right", color: "#7393B3" },
    OtherLeft_LE_p: { label: "Other left", color: "#997570" },
    OtherCentre_LE_p: { label: "Other centre", color: "#999999" },
    turnout_LE_p: { label: "Turnout", color: "#999999" },

    past_vote_CDA: { label: "CDA", color: "#339933" },
    past_vote_D66: { label: "D66", color: "#2cc800" },
    past_vote_DidNotVote: { label: "Did not vote", color: "#94A3B8" },
    past_vote_GLpvdA: { label: "GL–PvdA", color: "#920c19" },
    past_vote_OtherCentre: { label: "Other centre", color: "#999999" },
    past_vote_OtherLeft: { label: "Other left", color: "#997570" },
    past_vote_OtherRight: { label: "Other right", color: "#7393B3" },
    past_vote_PVV: { label: "PVV", color: "#043555" },
    past_vote_VVD: { label: "VVD", color: "#0e2783" },
    past_vote_turnout: { label: "Turnout", color: "#999999" },
  };

  // helpers
  const fmtPct0 = (x) => (Number.isFinite(x) ? `${x.toFixed(0)}%` : "n/a");
  const fmtCI = (lwr, upr) =>
    Number.isFinite(lwr) && Number.isFinite(upr) ? ` [${lwr.toFixed(0)}%–${upr.toFixed(0)}%]` : "";

  // Find the chosen party row
  const chosen = predictedValues.find(d => d.key === this.props.chosenParty) || null;

  const predicted = chosen ? Number(chosen.value) : NaN;
  const lwr = chosen?.lower;
  const upr = chosen?.upper;

  // Get "previous" vote (for comparison)
  let vote2025 = NaN;
  {

      let pastKey
      
      pastKey = this.props.chosenParty
        .replace("_GE_p", "")
        .replace("_LE_p", "")
        .replace("past_vote_", "");

      pastKey = pastKey==="turnout" ? "past_turnout": pastKey



    // your original logic had both branches doing the same thing; kept behaviour
    vote2025 = (comparatorFeature?.properties?.[pastKey] ?? NaN) * 100;
  }

  // Compute change
  const change = Number.isFinite(predicted) && Number.isFinite(vote2025)
    ? (predicted - vote2025)
    : NaN;

  // Area label
  let area_type_label;
  switch (geoLevel) {
    case "geementen":
      area_type_label = "Gemeente";
      break;
    case "buurt":
      area_type_label = "Buurt";
      break;
    default:
      area_type_label = geoLevel;
      break;
  }

  const party = partyConfig[this.props.chosenParty];

  return (
    <>
      {Number.isFinite(predicted) && party && (
        <div style={{ fontSize: "13px" }}>
          <strong>{area_name}</strong> {area_type_label}
          <br />
          <span style={{ color: party.color }}>
            {party.label} {party.label==="Turnout" ? "estimate":"vote share"}: <b>{fmtPct0(predicted)}</b>
            {fmtCI(lwr, upr)}
          </span>
          {" "}
          {Number.isFinite(change) && (
            <>
              ({change > 0 ? "+" : ""}{change.toFixed(0)}% since 2025)
            </>
          )}
        </div>
      )}
    </>
  );
}






 

  render() {    
    const {  styledGeo,  hoverInfo} = this.props;

    return (
            <>  
        { styledGeo && hoverInfo && hoverInfo?.props?.topValue &&(
          <Popup
            longitude={hoverInfo.lon}
            latitude={hoverInfo.lat}
            closeButton={false}
            closeOnClick={false}
            offset={12}
            dynamicPosition={true}
            maxWidth="500px"
          >
            {this.buildTooltip(hoverInfo, styledGeo,this.props.tooltip_pastcomp)}
          </Popup>
        )}
          </>
    )}
    }
    
    export default withRouter(NZ2026HomeTooltip);
    